import { styled, Switch, useId, DropdownMenu } from '@showroomjs/ui';
import * as React from 'react';
import { CheckIcon } from '@heroicons/react/solid';
import { useTargetAudience, useTargetAudienceDispatch, } from '../lib/use-target-audience';
import { Div } from './base';
export const AudienceToggle = () => {
    const targetAudience = useTargetAudience();
    const setTargetAudience = useTargetAudienceDispatch();
    const id = useId();
    return (React.createElement(Div, { css: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '$3',
            px: '$3',
            py: '$3',
        } },
        React.createElement(Label, { htmlFor: id }, targetAudience === 'developer' ? 'Code' : 'Design'),
        React.createElement(Switch, { checked: targetAudience === 'developer', onCheckedChange: (checked) => setTargetAudience(checked ? 'developer' : 'designer'), id: id },
            React.createElement(Switch.Thumb, null))));
};
export const AudienceDropdownGroup = () => {
    const targetAudience = useTargetAudience();
    const setTargetAudience = useTargetAudienceDispatch();
    return (React.createElement(React.Fragment, null,
        React.createElement(DropdownMenu.Separator, null),
        React.createElement(DropdownMenu.Label, null, "View As"),
        React.createElement(DropdownMenu.RadioGroup, { value: targetAudience, onValueChange: (val) => setTargetAudience(val) },
            React.createElement(DropdownMenu.RadioItem, { value: "designer" },
                "Designer",
                React.createElement(DropdownMenu.ItemIndicator, { css: {
                        left: 'auto',
                        right: 8,
                    } },
                    React.createElement(Icon, { width: 20, height: 20 }))),
            React.createElement(DropdownMenu.RadioItem, { value: "developer" },
                "Engineer",
                React.createElement(DropdownMenu.ItemIndicator, { css: {
                        left: 'auto',
                        right: 8,
                    } },
                    React.createElement(Icon, { width: 20, height: 20 }))))));
};
const Label = styled('label', {
    width: 56,
    display: 'block',
    color: '$gray-500',
    fontSize: '$sm',
    textTransform: 'uppercase',
});
const Icon = styled(CheckIcon, {
    color: '$primary-500',
});
//# sourceMappingURL=audience-toggle.js.map